<div class="treaty-country-pair-selector-button-container">
  <button attr.data-cy="{{command.title}}"
          mat-button
          (click)="countryOneClicked(command)"
          [ngClass]="command.fieldValues['Css']" [disabled]="command.isDisabled">
    <div *ngIf="command.fieldValues['CountryOne']" class="flex flex-row justify-start items-center">
      <div class="fflag ff-md fflag-{{command.fieldValues['CountryOne'].code}}"></div>
      <span class="label">
            {{command.fieldValues['CountryOne'].displayName}}
          </span>
      <i *ngIf="command.icon && command.icon.length>0" [ngClass]="command.icon"></i>
    </div>
  </button>
  <button attr.data-cy="{{command.title}}"
          mat-button
          (click)="countryTwoClicked(command)"
          [ngClass]="command.fieldValues['Css']" [disabled]="command.isDisabled">

    <div *ngIf="command.fieldValues['CountryTwo']" class="flex flex-row justify-start items-center">
      <div class="fflag ff-md fflag-{{command.fieldValues['CountryTwo'].code}}"></div>
      <span class="label">
            {{command.fieldValues['CountryTwo'].displayName}}
          </span>
      <i *ngIf="command.icon && command.icon.length>0" [ngClass]="command.icon"></i>
    </div>
  </button>
  <button [hidden]="true" attr.data-cy="{{command.title}}"
          mat-button
          (click)="cancelClicked(command)"
          [ngClass]="command.fieldValues['Css']" [disabled]="command.isDisabled">
    <i class="fa-solid fa-circle-xmark"></i>
  </button>

</div>
